import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import ThemeToggle from '../ui/ThemeToggle';
import ShareNotifications from '../sharing/ShareNotifications';

const Navbar = () => {
  const { isAuthenticated, logout, user } = useAuthContext();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  const onLogout = () => {
    logout();
  };
  
  const authLinks = (
    <>
      {/* Desktop Menu */}
      <ul className="hidden md:flex items-center space-x-4">
        <li>
          <ShareNotifications />
        </li>
        <li>
          <span className="text-gray-700 dark:text-gray-300">
            Ciao, {user && user.name}
          </span>
        </li>
        <li>
          <button
            onClick={onLogout}
            className="bg-red-500 hover:bg-red-700 text-white font-semibold py-1 px-3 rounded transition-colors"
          >
            Esci
          </button>
        </li>
        <li>
          <ThemeToggle />
        </li>
      </ul>

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="p-2 rounded-lg text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white focus:outline-none"
        >
          <svg
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
            />
          </svg>
        </button>
      </div>
    </>
  );
  
  const guestLinks = (
    <ul className="flex items-center space-x-4">
      <li>
        <Link
          to="/register"
          className="text-gray-700 dark:text-gray-300 hover:text-blue-500 dark:hover:text-blue-400 transition-colors"
        >
          Registrati
        </Link>
      </li>
      <li>
        <Link
          to="/login"
          className="bg-blue-500 hover:bg-blue-700 text-white font-semibold py-1 px-3 rounded transition-colors"
        >
          Accedi
        </Link>
      </li>
      <li>
        <ThemeToggle />
      </li>
    </ul>
  );

  // Mobile Menu
  const mobileMenu = isAuthenticated && isMenuOpen && (
    <div className="md:hidden">
      <div className="px-2 pt-2 pb-3 space-y-1 bg-white dark:bg-gray-800 shadow-lg rounded-b-lg">
        <div className="flex items-center justify-between p-2">
          <ShareNotifications />
          <span className="text-gray-700 dark:text-gray-300">
            {user && user.name}
          </span>
        </div>
        <button
          onClick={onLogout}
          className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-white bg-red-500 hover:bg-red-700 transition-colors"
        >
          Esci
        </button>
      </div>
    </div>
  );
  
  return (
    <nav className="bg-white dark:bg-gray-800 shadow-md">
      <div className="container mx-auto px-6 py-3">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors">
            Gestione Attività
          </Link>
          
          <div>{isAuthenticated ? authLinks : guestLinks}</div>
        </div>
        {mobileMenu}
      </div>
    </nav>
  );
};

export default Navbar;